import { useQuery } from "@tanstack/react-query"
import { paths } from "../apiTypes"

export type EarnVaultsResponse =
  paths["/v1/earn/vaults"]["get"]["responses"]["200"]["content"]["application/json"]

export function useEarnVaultsIndexer<TData = EarnVaultsResponse>(
  chainId: number,
  {
    take = 10_000, //TODO: later we can paginate and sort/order
    skip = 0,
    select,
    enabled = true,
  }: {
    take?: number
    skip?: number
    select?: (data: EarnVaultsResponse) => TData
    enabled?: boolean
  } = {},
) {
  if (!process.env.NEXT_PUBLIC_EULER_API_URL) {
    throw new Error("NEXT_PUBLIC_EULER_API_URL is not set")
  }
  const params = new URLSearchParams({
    chainId: chainId.toString(),
    take: take.toString(),
    skip: skip.toString(),
  })
  const url = `${
    process.env.NEXT_PUBLIC_EULER_API_URL
  }/v1/earn/vaults?${params.toString()}`

  return useQuery<EarnVaultsResponse, Error, TData>({
    queryKey: ["earnVaultsIndexer", chainId],
    queryFn: async () => {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(
          `Failed to fetch vaults from indexer, status: ${response.status}, url: ${url}`,
        )
      }
      return response.json()
    },
    select: (data) => (select ? select(data) : (data as TData)),
    enabled: enabled && !!chainId,
  })
}
